const valorUnidad = {
  Validar: (pvalor, punidad) => {
    let error = "";
    let valor = "";

    if (pvalor != null) {
      pvalor = pvalor.toString();
    }

    if (punidad !== "PE") {
	  if (pvalor != null) {
		  valor = pvalor.replace(/[^0-9,]/g, "") || "";
		  if (valor === ",") {
			valor = "0,";
		  }
		  if ((valor.match(new RegExp(",", "g")) || []).length > 1) {
			valor = valor.replace(/,$/, "");
		  }
	  }
    }

    switch (punidad) {
      case "PE":
        if (pvalor != null) {
          valor = pvalor.replace(/[^0-9]/g, "").substring(0, 10);
          if ((parseInt(valor, 0) < 100)) {
            error = "debe ser mayor o igual a 100";
          }
        }
        break;

      case "VE":
        if (valor.split(",").length > 1) {
          valor = `${valor.split(",")[0]},${valor.split(",")[1].substring(0, 4)}`.substring(0, 10);
        } else {
          valor = valor.substring(0, 10);
        }
        if (parseFloat(valor.replace(",", "."), 0) > 20) {
          error = "debe ser Menor o igual a 20";
        }
        break;

      case "VC":
        if (valor.split(",").length > 1) {
          valor = `${valor.split(",")[0]},${valor.split(",")[1].substring(0, 4)}`.substring(0, 10);
        } else {
          valor = valor.substring(0, 10);
        }
        if (parseFloat(valor.replace(",", "."), 0) >= 1) {
          error = "debe ser Menor a 1";
        }
        break;

      default:
        error = "Seleccionar unidad";
    }

    return {
      error,
      valor
    };
  },
};

export default valorUnidad;
